import { render } from "./TheTestimonial.vue?vue&type=template&id=6dcbbc84"
import script from "./TheTestimonial.vue?vue&type=script&lang=js"
export * from "./TheTestimonial.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__